import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";

/** Accept-invite now lives on account-web — bounce old bookmarks. */
export const Route = createFileRoute("/accept-invite")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/accept-invite", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: () => null,
});
